import { useEffect, useState } from "react";

const useAdManagerService = (adManager) => {
  const [isReady, setIsReady] = useState(adManager.isInitialized);

  useEffect(() => {
    if (!adManager) {
      console.error(`Ad Manager service is not available.`);
      return;
    }

    if (adManager.registerToProviderReady) {
      adManager.registerToProviderReady(null, (isInitialized) => {
        setIsReady(isInitialized);
      });
    } else {
      setIsReady(adManager.isInitialized);
    }
  }, [adManager]);

  return {
    adManager: adManager,
    isInitialized: isReady,
  };
};

export default useAdManagerService;